// Chinese translations (Simplified)
const zh = {
  // Placeholder structure to prevent errors
  navigation: {
    tracking: "追踪",
    search: "搜索",
    login: "我的MSC",
    language: "语言"
  },
  
  menu: {
    solutions: "解决方案",
    industries: "行业",
    ebusiness: "电子商务",
    sustainability: "可持续发展",
    aboutUs: "关于我们",
    schedules: "船期查询"
  },
  
  hero: {
    leaderIn: "行业领先",
    shippingLogistics: "航运和物流",
    trackingTab: "货物追踪",
    schedulesTab: "船期查询",
    contactsTab: "联系我们",
    containerBol: "集装箱/提单号码",
    bookingNumber: "订舱号码",
    searchPlaceholder: "搜索我们的服务和解决方案...",
    searchButton: "搜索"
  },
  
  // Default fallback for other sections
  example: {},
  services: {},
  stats: {
    title: "全球覆盖，本地专长",
    description: "凭借强大的全球网络和深厚的本地知识，我们连接跨大陆的企业。",
    years: "年经验",
    countries: "服务国家",
    clients: "活跃客户",
    shipments: "年运输量"
  },
  industries: {},
  footer: {}
};

export default zh; 